var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 16,
    viewBox: "0 0 36 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_301115054643303576075567268411093971979",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_41592169009785343927885190968100007823",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_244763104932423757314422693256768009980",
    d: "M7.75 12l.536-1.612h2.827L11.658 12h1.712l-2.927-7.82H8.951L6.038 12H7.75zm2.927-2.917H8.721l.976-2.927.98 2.927zm5.213 3.022c.676 0 1.206-.233 1.588-.698l.043.593h1.464V6.19h-1.56v4.112c-.197.367-.559.55-1.085.55-.552 0-.827-.303-.827-.909V6.19h-1.55v3.807c.006.692.174 1.216.502 1.574.329.357.804.535 1.425.535zm6.237 0c.322 0 .634-.046.937-.138V10.79c-.13.026-.282.038-.454.038-.233 0-.39-.046-.473-.138-.083-.093-.125-.248-.125-.464V7.327h.995V6.19h-.995V4.76h-1.55v1.43h-.85v1.138h.85v3.133c.02 1.097.575 1.645 1.665 1.645zm4.256 0c.839 0 1.507-.27 2.004-.808.498-.539.746-1.253.746-2.143l-.01-.397c-.056-.825-.333-1.478-.829-1.958-.496-.48-1.136-.72-1.92-.72-.552 0-1.036.124-1.454.37-.418.248-.737.597-.959 1.048-.222.451-.332.965-.332 1.543v.071c0 .925.25 1.655.748 2.19.5.536 1.168.804 2.006.804zm0-1.248c-.385 0-.682-.146-.89-.438-.206-.291-.31-.713-.31-1.265 0-.621.104-1.08.31-1.375.208-.295.501-.442.88-.442.384 0 .68.149.893.447.212.298.318.717.318 1.256 0 .634-.106 1.096-.318 1.384-.212.289-.506.433-.883.433z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#454545",
    xlinkHref: "#hinava_random_uuid_244763104932423757314422693256768009980"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_301115054643303576075567268411093971979)",
    xlinkHref: "#hinava_random_uuid_244763104932423757314422693256768009980"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 15,
    x: 0.5,
    y: 0.5,
    stroke: "url(#hinava_random_uuid_41592169009785343927885190968100007823)",
    rx: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.3572eae9295bc94451407c24c3d13e7e.svg";
export { ForwardRef as ReactComponent };